// extracted by mini-css-extract-plugin
export default {"items_container":"Home_items_container__A64UJ","home":"Home_home__uEIM2"};